var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2374 3.17663C16.554 2.49321 15.446 2.49321 14.7626 3.17663L2.76256 15.1766C2.43437 15.5048 2.25 15.9499 2.25 16.4141V19.9998C2.25 20.9663 3.0335 21.7498 4 21.7498H7.58579C8.04992 21.7498 8.49503 21.5655 8.82322 21.2373L18.5263 11.5342L18.5303 11.5302L18.5343 11.5262L20.8232 9.23729C21.5066 8.55387 21.5066 7.44583 20.8232 6.76241L17.2374 3.17663ZM18 9.9392L19.7626 8.17663C19.8602 8.079 19.8602 7.9207 19.7626 7.82307L16.1768 4.23729C16.0791 4.13966 15.9209 4.13965 15.8232 4.23729L14.0606 5.99986L18 9.9392ZM13 7.06052L3.82322 16.2373C3.77634 16.2842 3.75 16.3478 3.75 16.4141V19.9998C3.75 20.1379 3.86193 20.2498 4 20.2498H7.58579C7.65209 20.2498 7.71568 20.2235 7.76256 20.1766L16.9393 10.9999L13 7.06052Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostIcon);
export default __webpack_public_path__ + "static/media/postIcon.b67bd5a4832dcd59afea566619fc163b.svg";
export { ForwardRef as ReactComponent };